import { RootState } from "@/app/stores"
import { getDashboardCards, createBusinessCard as createBusinessCardAPI, ICreateBusinessCardRequest, IDashboardCard } from "@/shared/api/onboarding"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchBusinessCards = createAsyncThunk<
    IDashboardCard[],
    void,
    { state: RootState }
>('businessCards/fetchBusinessCards', async (_, thunkAPI) => {
    try {
        const data = await getDashboardCards()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const createBusinessCard = createAsyncThunk<
    IDashboardCard,
    ICreateBusinessCardRequest,
    { state: RootState }
>('businessCards/createBusinessCard', async (data, thunkAPI) => {
    try {
        const response = await createBusinessCardAPI(data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

